export { DutchiePrivacyFooter } from './dutchie-privacy-footer';
